export default function Car({ ...rest }: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M18.947 5.013A1.499 1.499 0 0 0 17.529 4H6.471c-.64 0-1.211.407-1.418 1.013L3 11v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.053-5.987zM6.829 6h10.343l1.371 4H5.457l1.372-4zM6.5 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 15zm11 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 15z" />
    </svg>
  )
}
